// import React from 'react'
// import './login.css'
// import { Link } from 'react-router-dom'
// import laptop from"../../assets/laptop.png"
// import { useState, useEffect } from 'react'
// import { useContext } from 'react'
// import { AppContext } from '../../App'
// import { useNavigate } from 'react-router-dom'
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// const Login = () => {
//   const history =useNavigate()
// const   {login,setLogin,route}=useContext(AppContext)
// const   {loader,setLoader}=useContext(AppContext)
//   const [email,setEmail]=useState("")
//   const [password,setPassword]=useState("")
//   const [wrong,setWrong]=useState(false)

//   const handleEmail =(e)=>{
//     setEmail(e.target.value)
//   }
//   const handlePassword =(e)=>{
//     setPassword(e.target.value)
//   }

//   const handleLogin = async (event) => {
//     event.preventDefault();
//     setLoader(true)
  
//     const formData = new FormData();
//     formData.append('id', email);
//     formData.append('password', password);
//     try {
//       const response = await fetch(`${route}/auth/login`, {
//         method: 'POST',
//         body: formData,
//       })
//       .then(res=>res.json())
//       console.log(response)
//        setLoader(false)
//        if(response.msg){
//         toast.error(response.msg)
//        }
//       if (response.status=="Success") {
       
//         sessionStorage.setItem("login",true)
//         sessionStorage.setItem("token",response.token)
    
//         sessionStorage.setItem("userName",response.user.name)
//         sessionStorage.setItem("id",response.user.id)
//         sessionStorage.setItem("email",response.user.email)
      
//         history("/main-page")
//         setLogin(true)
//       } else {
//      toast.error(response.error)
//        }
//     } catch (error) {
//       console.error(error);
    
//     }
//   };







//   return (
//     <div className="login">
//         <div className="container">
//             <div className="login-text">
//             <h3>مرحبا بك في منصتنا</h3>
//             <img src={laptop} alt="" />
//             <p>تنويه - في حال نسيت كلمة المرور ارسل رقم المكتب الخاص + صورة الهوية ملونة على الوجهين الى ايميل الشركة او عبر صفحة اتصل بنا</p>
//             </div>
//             <form onSubmit={handleLogin}>
//             <h3>تسجيل الدخول</h3>
//             {wrong?<div className='wrong'>هناك خطا بكلمة السر او الايميل !!</div>:null}

//             <input onChange={handleEmail} value={email} type='text' placeholder='ادخل الايميل الخاص بك'/>
//             <input onChange={handlePassword} value={password} type='text' placeholder='ادخل كلمة السر'/>
//             <button type='submit'>تسجيل الدخول </button>
          

//             </form>
//         </div>
//     </div>
//   )
// }  

// export default Login


import React, { useState, useContext } from 'react'
import './login.css'
import { AppContext } from '../../App'
import { useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const Login = () => {
  const navigate = useNavigate()
  const { setLogin, route, loader, setLoader } = useContext(AppContext)

  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")

  const handleLogin = async (e) => {
    e.preventDefault()
    setLoader(true)

    const formData = new FormData()
    formData.append("id", email)
    formData.append("password", password)

    try {
      const response = await fetch(`${route}/auth/login`, {
        method: "POST",
        body: formData
      }).then(res => res.json())

      setLoader(false)

      if (response.status === "Success") {
        sessionStorage.setItem("login", true)
        sessionStorage.setItem("token", response.token)
        sessionStorage.setItem("userName", response.user.name)
        sessionStorage.setItem("id", response.user.id)
        sessionStorage.setItem("email", response.user.email)

        setLogin(true)
        navigate("/main-page")
      } else {
        toast.error(response.msg || response.error)
      }
    } catch {
      setLoader(false)
      toast.error("حدث خطأ أثناء تسجيل الدخول")
    }
  }

  return (
    <div className="login-split">
      <ToastContainer />

      {/* Visual Side */}
      <div className="login-visual">
        <div className="visual-content">
          <h2>مؤسسة نبض المستقبل</h2>
          <p>صناع ونبض المستقبل </p>
        </div>

        <div className="floating-shape"></div>
      </div>

      {/* Form Side */}
      <div className="login-form-wrapper">
        <form className="login-form" onSubmit={handleLogin}>
          <h3>Welcome Back</h3>
          <span>سجل دخولك للمتابعة</span>

          <input
            type="text"
            placeholder="البريد الإلكتروني"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="كلمة المرور"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button type="submit" disabled={loader}>
            {loader ? <span className="loader"></span> : "Login"}
          </button>
        </form>
      </div>
    </div>
  )
}

export default Login
